webpackJsonp([83],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export floatMenu */
/**
 * Created by lycheng on 2017/12/4.
 * 右边导航
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    difference: 5, // 为了避免top与tops临界点差值过小时，animate不触发的问题
    $container: $('html,body'),
    checkedClass: 'nav-checked'
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-custom-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top + floatMenu.config.difference;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-custom-nav-fall');
      var $navItem = $('.js-custom-nav-fall li');
      var targets = [];
      var i = 0;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        if ($('.' + targets[i]).offset()) {
          tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
        }
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 300) {
        $navCon.show();
      } else {
        $navCon.hide();
      }
    }

  }
};
floatMenu.init();


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_libs_common__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_topbar_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_utils__ = __webpack_require__(1);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */






function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["h" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.banner-apply-btn').click(function () {
    var $this = $(this);
    var href = $this.data('href');
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils__["h" /* toUrl */])(href, '_blank');
  });
}

function init() {
  Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
  bindEvent();
}
init();

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(4);

// EXTERNAL MODULE: ./src/js/libs/utils-layer.js
var utils_layer = __webpack_require__(7);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(6);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */







function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension(s, isIndex) {
  var $suspension = $('.suspension');
  if (!$suspension.length) {
    return;
  }
  var show400 = !(Object(utils["d" /* isWorkTime */])() && Object(utils["e" /* isWorkday */])());
  if (show400) {
    $('#feedback_btn').before('\n    <div class="suspension-item-wrap suspension-phone-wrap">\n      <i class="icons icons-suspension-phone"></i>\n      <div>\n        <div class="suspension-number-title">\u670D\u52A1\u70ED\u7EBF</div>\n        <p class="suspension-number-phone">4000-199-199</p>\n      </div>\n    </div>\n    ');
  }
  var $backTop = $('.suspension-back-top');
  var $susIcon = $('.sus-icon');
  var winH = $(window).height();
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < s - winH / 2) {
      $suspension.css({
        position: 'absolute',
        top: s + 'px'
      });
    } else {
      $suspension.css({
        position: 'fixed',
        top: '50%'
      });
    }
    if (scrollTop > winH / 2) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $(window).scroll();
  $backTop.click(function () {
    $('body, html').animate({ 'scrollTop': 0 }, 500);
    return false;
  });

  function checkImLog() {
    user["d" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["f" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + '/login?jump=' + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  checkImLog();

  // $(".im-icon").click(function () {
  //   checkImLog()
  // });
}


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_non_contact_equipment_scss__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_solutions_non_contact_equipment_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_solutions_non_contact_equipment_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_solutions__ = __webpack_require__(12);




(function () {
  $('.banner-buy-btn').click(function () {
    var top = $('.solutions-item-partner').offset().top - 80;
    $('html,body').animate({ scrollTop: Math.floor(top) }, 500);
  });
  // 应用场景
  var _sceneContext = $('.solutions-item-scene .solutions-item-context');
  var _sceneLi = $('.solutions-item-scene .solutions-item-content li');
  _sceneLi.on('click', function () {
    _sceneLi.removeClass('selected');
    $(this).addClass('selected');
    _sceneContext.html('').append('\n      <p>' + $(this).data('title') + '</p>\n      <p>' + $(this).data('desc') + '</p>\n      <p>' + $(this).data('tech') + '</p>\n    ');
  });
  // 优质合作产品
  var _partnerLi = $('.solutions-item-partner .solutions-item-content li');
  var _partnerContent = $('.solutions-item-partner .solutions-item-context .content');
  var _partnerVideo = $('.solutions-item-partner .partner-video');
  var partnerHtml = '';
  _partnerLi.on('click', function () {
    _partnerLi.removeClass('selected');
    $(this).addClass('selected');
    if ($(this).data('type') === 'dct') {
      partnerHtml = '\n        <p>\u7531\u5408\u4F5C\u670D\u52A1\u5546\u2014\u2014\u4E1C\u8D85\u79D1\u6280\u4E0E\u4E2D\u56FD\u79D1\u6280\u5927\u5B66\u7B2C\u4E00\u9644\u5C5E\u533B\u9662\u8054\u5408\u63A8\u51FA\u7684\u65E0\u63A5\u89E6\u5F0F\u591A\u529F\u80FD\u81EA\u52A9\u7EC8\u7AEF\u8BBE\u5907\u3002\u8BE5\u81EA\u52A9\u673A\u4F7F\u7528\u8005\u4E0D\u9700\u8981\u4E0E\u5C4F\u5E55\u63A5\u89E6\uFF0C\u70B9\u51FB\u7A7A\u4E2D\u6210\u50CF\uFF0C\u5C31\u80FD\u5B8C\u6210\u6302\u53F7\u9884\u7EA6\u7F34\u8D39\u7B49\u591A\u529F\u80FD\u81EA\u52A9\u670D\u52A1\u3002</p>\n        <p>\u533B\u9662\u4F5C\u4E3A\u53EF\u80FD\u5B58\u5728\u4F20\u67D3\u6E90\u53C8\u6709\u5927\u91CF\u6613\u611F\u4EBA\u7FA4\u7684\u516C\u4F17\u573A\u6240\uFF0C\u5C31\u8BCA\u8005\u3001\u63A2\u89C6\u8005\u3001\u75C5\u4EBA\u5BB6\u5C5E\u3001\u533B\u52A1\u5DE5\u4F5C\u8005\uFF0C\u5404\u7C7B\u4EBA\u7FA4\u5BC6\u96C6\uFF0C\u505A\u597D\u9662\u5185\u611F\u67D3\u7684\u9884\u9632\u5C24\u5176\u91CD\u8981\u3002\u533B\u9662\u7684\u81EA\u52A9\u670D\u52A1\u673A\uFF0C\u6BCF\u5929\u6709\u6570\u4EE5\u5343\u8BA1\u7684\u60A3\u8005\u53CA\u5BB6\u5C5E\u89E6\u6478\u4F7F\u7528\uFF0C\u5B58\u5728\u4EA4\u53C9\u611F\u67D3\u7684\u98CE\u9669\u3002</p>\n        <p>\u91C7\u7528\u8BE5\u6280\u672F\u5347\u7EA7\u540E\u7684\u8BBE\u5907\u533A\u522B\u4E8E\u4F20\u7EDF\u6210\u50CF\u539F\u7406\uFF0C\u53EF\u4EE5\u65E0\u4ECB\u8D28\u7A7A\u4E2D\u6210\u50CF\uFF0C\u6446\u8131\u6210\u50CF\u4ECB\u8D28\u7684\u675F\u7F1A\uFF0C\u4EE5\u5B9E\u50CF\u7684\u5F62\u5F0F\u5C06\u753B\u9762\u76F4\u63A5\u5448\u73B0\u5728\u7A7A\u6C14\u4E2D\u5E76\u53EF\u76F4\u63A5\u4EA4\u4E92\u64CD\u4F5C\u3002\u4F7F\u7528\u8005\u4E0D\u9700\u8981\u4E0E\u5C4F\u5E55\u63A5\u89E6\uFF0C\u5168\u90E8\u64CD\u4F5C\u90FD\u5728\u7A7A\u6C14\u4E2D\u5B8C\u6210\uFF0C\u6709\u6548\u964D\u4F4E\u4E86\u56E0\u4EBA\u4F53\u4E0E\u7269\u4F53\u8868\u9762\u63A5\u89E6\u65F6\u53D1\u751F\u4EA4\u53C9\u611F\u67D3\u7684\u53EF\u80FD\u6027\u3002</p>\n        <div>\n          <button>\u89C6\u9891\u4ECB\u7ECD</button>\n          <a href="http://www.aifuwus.com/onstage/cmdpreview?id=1582" target="_blank">\u67E5\u770B\u8BE6\u60C5</a>\n        </div>\n      ';
      document.getElementById('video-intro-non-contact').src = '//aicontest2019.cn-bj.ufileos.com/file%2FDCT.mp4';
    } else if ($(this).data('type') === 'aiui') {
      partnerHtml = '\n        <p>\u79D1\u5927\u8BAF\u98DE\u4E0E\u5408\u80A5\u8F68\u9053\u5408\u4F5C\u7684\u5728\u5408\u80A5\u5730\u94C12\u53F7\u7EBF\u6F5C\u5C71\u8DEF\u7AD9\u7684\u8BED\u97F3\u8D2D\u7968\u673A\u3002\u8BED\u97F3\u552E\u7968\u7684\u4F7F\u7528\u65B9\u6CD5\u975E\u5E38\u7B80\u5355\uFF0C\u4E58\u5BA2\u53EA\u9700\u5BF9\u7740\u673A\u5668\u8BF4\u81EA\u5DF1\u8981\u53BB\u54EA\u91CC\uFF0C\u6BD4\u5982\u201C\u6211\u8981\u53BB\u5B89\u5FBD\u519C\u4E1A\u5927\u5B66\u201D\uFF0C\u8BED\u97F3\u552E\u7968\u673A\u5C31\u4F1A\u667A\u80FD\u63A8\u8350\u4F60\u201C\u5B89\u519C\u5927\u7AD9\u201D\uFF0C\u4E58\u5BA2\u4F7F\u7528\u624B\u673A\u626B\u7801\u4ED8\u6B3E\u5373\u53EF\u5B8C\u6210\u8D2D\u7968\uFF0C\u5168\u7A0B\u4E0D\u8FC7\u5341\u51E0\u79D2\u949F\uFF0C\u5E76\u4E14\u4E0D\u9700\u8981\u5728\u673A\u5668\u4E0A\u8FDB\u884C\u4EFB\u4F55\u624B\u52A8\u64CD\u4F5C\uFF0C\u907F\u514D\u4E86\u63A5\u89E6\u5E26\u6765\u7684\u4EA4\u53C9\u611F\u67D3\u98CE\u9669\u3002</p>\n        <div>\n          <button>\u89C6\u9891\u4ECB\u7ECD</button>\n          <a href="//aiui.iflyos.cn/index-aiui" target="_blank">\u67E5\u770B\u8BE6\u60C5</a>\n        </div>\n      ';
      document.getElementById('video-intro-non-contact').src = '//aicontest2019.cn-bj.ufileos.com/file%2F%E5%9C%B0%E9%93%81%E8%B4%AD%E7%A5%A8.mp4';
    } else {
      partnerHtml = '\n        <p>\u57FA\u4E8E\u79D1\u5927\u8BAF\u98DE\u81EA\u7814\u4EBA\u8138\u7B97\u6CD5\uFF0C\u5B9E\u73B0\u6838\u5FC3\u529F\u80FD\u3002\u5305\u62EC\u4EBA\u8138\u9A8C\u8BC1\u53CA\u68C0\u7D22\u3001\u4EBA\u8138\u68C0\u6D4B\u3001\u4EBA\u8138\u5173\u952E\u70B9\u5B9A\u4F4D\u3001\u4EBA\u8138\u8D28\u91CF\u8BC4\u4EF7\u3001\u6D3B\u4F53\u68C0\u6D4B\u3001\u773C\u90E8\u5634\u90E8\u68C0\u6D4B\u7B49\u529F\u80FD\uFF0C\u5176\u4E2D\u4EBA\u8138\u68C0\u6D4B\u3001\u6D3B\u4F53\u68C0\u6D4B\u3001\u7279\u5F81\u8BC6\u522B\u68C0\u7D22\u5168\u6D41\u7A0B\u8017\u65F6300ms\u4EE5\u5185\uFF0C\u9AD8\u6548\u6D41\u7545\u30022w\u5E95\u5E93\u5B9E\u6D4B\uFF0C0.1%\u5192\u8BA4\u7387\uFF0C\u8BC6\u522B\u51C6\u786E\u738798%\u4EE5\u4E0A\uFF0C\u51C6\u786E\u5B89\u5168\u3002\u6574\u4F53\u6548\u679C\u4F18\u826F\uFF0C\u65E0\u9700\u643A\u5E26\u4EFB\u4F55\u7269\u54C1\u5373\u53EF\u5B8C\u6210\u8EAB\u4EFD\u9A8C\u8BC1\uFF0C\u540C\u65F6\u63D0\u4F9B\u5728\u7EBF\u63A5\u53E3\u3001\u79BB\u7EBFSDK\uFF0C\u53EF\u6EE1\u8DB3\u591A\u79CD\u4E1A\u52A1\u9700\u6C42\u3002</p>\n        <div>\n          <a href="/solutions/authenticate" target="_blank">\u67E5\u770B\u8BE6\u60C5</a>\n          <a href="http://www.aifuwus.com/solution/index?link=stentor/notouch" target="_blank">\u5408\u4F5C\u54A8\u8BE2</a>\n        </div>\n      ';
    }
    _partnerContent.html('').append(partnerHtml);
    bindEventVideo();
  });
  // 弹出视频控制
  var bindEventVideo = function bindEventVideo() {
    _partnerContent.find('button').on('click', function () {
      _partnerVideo.show();
      document.getElementById('video-intro-non-contact').play();
    });
    _partnerVideo.find('.icon-close').on('click', function () {
      _partnerVideo.hide();
      document.getElementById('video-intro-non-contact').pause();
    });
  };
  bindEventVideo();
  // 特色优势
  var _adContext = $('.solutions-item-advantage .ability-advantage-content');
  var _adLi = $('.solutions-item-advantage .ability-tabs li');
  _adLi.on('click', function () {
    _adLi.removeClass('selected');
    $(this).addClass('selected');
    _adContext.html('').append('\n      <p>' + $(this).data('ad1') + '</p>\n      <p>' + $(this).data('ad2') + '</p>\n      <p>' + $(this).data('ad3') + '</p>\n    ');
  });
})();

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[603]);


// WEBPACK FOOTER //
// js/solutions/non-contact-equipment.4ddfcac911a010f34df2.bundle.js